import { paymentsTypes } from './payments.types';

export const fetchbillsStart = () => ({
  type: paymentsTypes.FETCH_BILLS_START,
});

export const fetchEngBillsStart = () => ({
  type: paymentsTypes.FETCH_ENG_BILLS_START,
});

export const validateDiscountCodeStart = ({ code, selectedPackageType }) => ({
  type: paymentsTypes.VALIDATE_DISCOUNT_CODE_START,
  payload: { code, selectedPackageType },
});

export const makeInvoiceStart = (invoiceCredentials) => ({
  type: paymentsTypes.MAKE_INVOICE_START,
  payload: invoiceCredentials,
});

export const makeInvoiceLoading = (isLoading) => ({
  type: paymentsTypes.MAKE_INVOICE_LOADING,
  payload: isLoading,
});

export const updateInCompleteUserInfoByModal = (userInfo) => ({
  type: paymentsTypes.UPDATE_IN_COMPLETE_USER_INFO_BY_MODAL,
  payload: userInfo,
});

export const fetchPaymentInfoStart = () => ({
  type: paymentsTypes.FETCH_PAYMENT_INFO_START,
});

export const makePaymentWithoutOfficialBill = (invoiceCredentials) => ({
  type: paymentsTypes.MAKE_PAYMENT_WITHOUT_OFFICIAL_BILL_START,
  payload: invoiceCredentials,
});

export const makePaymentWithoutOfficialBillEng = (invoiceCredentials) => ({
  type: paymentsTypes.MAKE_INVOICE_WITHOUT_OFFICIAL_BILL_ENG,
  payload: invoiceCredentials,
});

export const savePaymentInfoStart = (paymentCredentials) => ({
  type: paymentsTypes.SAVE_PAYMENT_INFO_START,
  payload: paymentCredentials,
});

export const redirectToAutoUpgradeStart = (autoUpgradeCredentials) => ({
  type: paymentsTypes.REDIRECT_TO_AUTO_UPGRADE_START,
  payload: autoUpgradeCredentials,
});

export const setBills = (bills) => ({
  type: paymentsTypes.SET_BILLS,
  payload: bills,
});

export const loadingBills = () => ({
  type: paymentsTypes.LOADING_BILLS,
});

export const loadingPaymentInfo = () => ({
  type: paymentsTypes.LOADIN_PAYMENT_INFO,
});

export const setDiscountCode = (discount) => ({
  type: paymentsTypes.SET_DISCOUNT_CODE,
  payload: discount,
});

export const setShowDiscountError = ({ discountError, show }) => ({
  type: paymentsTypes.SET_SHOW_DISCOUNT_ERROR,
  payload: { discountError, show },
});

export const fetchPackagesStart = (locale) => ({
  type: paymentsTypes.FETCH_PACKAGES_START,
  payload: locale,
});

export const setPackages = (packages) => ({
  type: paymentsTypes.SET_PACKAGES,
  payload: packages,
});

export const setPackageTypes = (packageTypes) => ({
  type: paymentsTypes.SET_PACKAGE_TYPES,
  payload: packageTypes,
});

export const loadingPackages = () => ({
  type: paymentsTypes.LOADING_PACKAGES,
});

export const setSelectedPackage = (selectedPackage) => ({
  type: paymentsTypes.SET_SELECTED_PACKAGE,
  payload: selectedPackage,
});

export const setSelectedPackageType = (selectedPackageType) => ({
  type: paymentsTypes.SET_SELECTED_PACKAGE_TYPE,
  payload: selectedPackageType,
});

export const setSelectedDuration = (selectedDuration) => ({
  type: paymentsTypes.SET_SELECTED_DURATION,
  payload: selectedDuration,
});

export const setIsOfficialBillNeeded = (isOfficialBillNeeded) => ({
  type: paymentsTypes.SET_IS_OFFICIAL_BILL_NEEDED,
  payload: isOfficialBillNeeded,
});

export const setUseCredit = (useCredit) => ({
  type: paymentsTypes.SET_USE_CREDIT,
  payload: useCredit,
});

export const setInvoiceId = (invoiceId) => ({
  type: paymentsTypes.SET_INVOICE_ID,
  payload: invoiceId,
});

export const setSelectedConversationCount = (conversationCount) => ({
  type: paymentsTypes.SET_SELECTED_CONVERSATION_COUNT,
  payload: conversationCount,
});

export const setPayablePrice = (payablePrice) => ({
  type: paymentsTypes.SET_PAYABLE_PRICE,
  payload: payablePrice,
});

export const setIsAutoUpgradeVisible = (isModalVisible) => ({
  type: paymentsTypes.SET_IS_AUTO_UPGRADE_VISIBLE,
  payload: isModalVisible,
});

export const FetchPaymentReportStart = (credentials) => ({
  type: paymentsTypes.FETCH_PAYMENT_REPORT_START,
  payload: credentials,
});

export const setSelectedBank = (bank) => ({
  type: paymentsTypes.SET_SELECTED_BANK,
  payload: bank,
});

export const setSelectedUpgradeMethod = (selectedUpgradeMethod) => ({
  type: paymentsTypes.SET_SELECTED_UPGRADE_METHOD,
  payload: selectedUpgradeMethod,
});

export const setPaymentInfo = (paymentInfo) => ({
  type: paymentsTypes.SET_PAYMENT_INFO,
  payload: paymentInfo,
});

export const setDisplayInputPaymentInfoModal = (isDisplayed) => ({
  type: paymentsTypes.DISPLAY_INPUT_PAYMENT_INFO_MODAL,
  payload: isDisplayed,
});

export const setIsSelectBankVisible = (isBankVisible) => ({
  type: paymentsTypes.SET_IS_SELECT_BANK_VISIBLE,
  payload: isBankVisible,
});

export const dispalySelectBankModalStart = (toggle) => ({
  type: paymentsTypes.DISPLAY_SELECT_BANK_MODAL_START,
  payload: toggle,
});

export const setUseWhatsappPackages = (packages) => ({
  type: paymentsTypes.SET_USE_WHATSAPP_PACKAGES,
  payload: packages,
});

export const validateSmsAndSaveUserInfo = (info) => ({
  type: paymentsTypes.VALIDATE_SMS_AND_SAVE_USER_INFO,
  payload: info,
});

export const checkUserInfo = ({ data, setLoading, setData }) => ({
  type: paymentsTypes.CHECK_USER_INFORMATION,
  payload: { data, setLoading, setData },
});
